<template>
    <!-- 社会功能开发课 -->
    <div class="shehuigongnengkaifake">
      <CertQuery :logo="Logo13" :type="'tsjy'" :color="'#294db0'" />
    </div>
  </template>
  
  <script>
  import CertQuery from '../component/certQuery.vue'
  import Logo13 from '@/assets/images/logo13.jpg'
  
  export default {
    name: 'SheHuiGongNengKaiFa',
    components: {
      CertQuery
    },
    data() {
      return {
        Logo13
      }
    }
  }
  </script>
  